import React, { Component } from "react";
import DBIndicator from "./DBIndicator";
import { propertyUtil } from "views/Pma/PropertyUtil";

class DBBody extends Component {
  calculatePlace = (cityOrArea) => {
    const { hoData, currentArea, demoAccountCity } = this.props;
    const { mlsNeighborhood, mlsCityName, mlsAreaID } = currentArea;
    const { subdivisionName, coverPageHeader } = hoData;
    const { splitAreas } = propertyUtil;

    let areaSplit = splitAreas(mlsNeighborhood);
    let separatedPlace;
    if (
      coverPageHeader &&
      coverPageHeader === "Upper East and Lower Mission Canyon"
    ) {
      separatedPlace = ["Upper East / Lower Mission Canyon"];
    } else if (demoAccountCity && demoAccountCity.length > 1) {
      separatedPlace = [demoAccountCity];
    } else if (subdivisionName && cityOrArea === "area") {
      separatedPlace = [subdivisionName];
    } else if (cityOrArea === "city") {
      separatedPlace = [mlsCityName];
    } else if (cityOrArea === "area") {
      let placeCount = mlsNeighborhood.length;
      if (mlsAreaID === "SBA-20FInv" || mlsAreaID === "SBA-20FRes") {
        separatedPlace = ["Downtown Santa Barbara"];
      } else if (areaSplit.length === 1) {
        separatedPlace = [mlsNeighborhood];
      } else if (areaSplit.length === 2) {
        if (placeCount > 22) {
          separatedPlace = [`${areaSplit[0]} / `, `${areaSplit[1]}`];
        } else {
          separatedPlace = [`${areaSplit[0]} / ${areaSplit[1]}`];
        }
      } else if (areaSplit.length === 3) {
        separatedPlace = [
          `${areaSplit[0]} / ${areaSplit[1]} /`,
          `${areaSplit[2]}`,
        ];
      } else if (areaSplit.length === 4) {
        separatedPlace = [
          `${areaSplit[0]} / ${areaSplit[1]} /`,
          `${areaSplit[2]} / ${areaSplit[3]}`,
        ];
      }
    }
    return separatedPlace;
  };
  createBottomLine = (count, cityOrArea, num) => {
    const {
      hoData,

      sentences,
    } = this.props;
    const { subdivisionName } = hoData;
    let benefitsCount = sentences
      .map((sentence) => sentence.benefit)
      .filter((adv) => adv === "Seller's").length;
    const { endsWithS, slashSeparatedArea } = propertyUtil;
    const { mlsNeighborhood, mlsCityName, mlsAreaID } = this.props.currentArea;
    let place;
    if (mlsAreaID === "ALA-2619I") {
      place = "Maxwell Park";
    } else if (subdivisionName && subdivisionName.length > 1) {
      place = subdivisionName;
    } else if (cityOrArea === "city") {
      place = mlsCityName;
    } else if (cityOrArea === "area") {
      if (mlsAreaID === "SBA-20FInv" || mlsAreaID === "SBA-20FRes") {
        place = "Downtown";
      } else if (
        mlsNeighborhood.length > 43 ||
        mlsAreaID === "SCL-16J" ||
        mlsAreaID === "SMA-390" ||
        mlsAreaID === "ALA-3900AK"
      ) {
        if (benefitsCount === "3") {
          place = "your neighborhood";
        } else {
          place = "your neighborhood's";
        }
      } else {
        if (benefitsCount === "3") {
          place = `the ${slashSeparatedArea(mlsNeighborhood)}`;
        } else {
          place = slashSeparatedArea(mlsNeighborhood);
        }
      }
    }

    if (mlsAreaID === "SCL-1Z") {
      return ` Inventory in Santa Clara County is up 29% YoY; sellers face a competitive market with less than 2 months' supply. Pricing is Key.`;
    } else if (mlsAreaID === "CCA-4500X") {
      return "In the current market, working with a knowledgeable, experienced agent to guide you is priceless.";
    } else if (mlsAreaID === "CCA-4700B") {
      return `Sellers are positioned well in this stable market with low inventory, though they should remain patient and proactive in their approach to account for extended selling times. Adequate pricing and effective marketing strategies are key to capitalizing on these market conditions.`;
    } else if (benefitsCount === 3) {
      return `3 out of 3 key Market Trends indicate that ${place} market conditions are favoring ${
        mlsAreaID === "SBA-20FInv" ? "" : "home"
      } sellers.`;
    } else if (benefitsCount === 2) {
      return `2 out of 3 Key Market Trends indicate that ${place} market conditions are favoring ${
        mlsAreaID === "SBA-20FInv" ? "" : "home"
      } sellers.`;
    } else if (benefitsCount === 1) {
      return `1 out of 3 Key Market Trends shows that the current ${place}${endsWithS(
        place
      )} market conditions are shifting away from a seller’s market towards more of a buyer’s market. `;
    } else if (benefitsCount === 0) {
      return `The three market measurements above are not indicating there are any current seller’s advantages –  but these numbers can change quickly.`;
    }
  };
  formatAreaName = () => {
    const { mlsNeighborhood, mlsAreaID } = this.props.currentArea;
    const { subdivisionName } = this.props.hoData;

    if (mlsAreaID === "CCA-4400P") {
      return "";
    } else if (subdivisionName) {
      return subdivisionName;
    } else if (mlsAreaID === "SCL-16J") {
      return "Your Neighborhood";
    } else if (mlsAreaID === "SMA-392") {
      return "Isle Cove - Neighborhood 9, Foster City";
    } else if (mlsAreaID === "SMA-398") {
      return "Treasure Isle - Neighborhood 1, Foster City";
    } else if (mlsAreaID === "SMA-390") {
      return "Sea Colony - Neighborhood 7, Foster City";
    } else if (mlsNeighborhood && mlsNeighborhood.length > 28) {
      return "Your Neighborhood";
    } else {
      return mlsNeighborhood;
    }
  };
  getTitleStyles = () => {
    const { mlsAreaID } = this.props.currentArea;
    if (mlsAreaID === "CCA-4400P") {
      return "no-header-title";
    } else if (
      mlsAreaID === "SMA-398" ||
      mlsAreaID === "SMA-390" ||
      mlsAreaID === "SMA-392"
    ) {
      return "medium-header-title";
    }
  };

  render() {
    const { formatAreaName } = this;
    const {
      sentences,
      actualAdvantagesCount,
      cityOrArea,
      agentData,
      currentArea,

      useSingleFamilyHomes,
    } = this.props;
    const { mlsAreaID } = currentArea;
    const { listgenUserID } = agentData;

    let titleStyles = this.getTitleStyles();
    let showBottomLine = true;
    if (mlsAreaID === "SBA-35J" || mlsAreaID === "CCA-4500R") {
      showBottomLine = false;
    }
    let bottomLineStyles;
    if (mlsAreaID === "CCA-4700B" || mlsAreaID === "CCA-4500M") {
      bottomLineStyles = "smaller-bottom-line-text";
    }
    let dbIndicatorContainerStyles;
    if (mlsAreaID === "CCA-4500R") {
      dbIndicatorContainerStyles = "centered-db-indicator-container";
    }
    return (
      <div className="db-body">
        {useSingleFamilyHomes ? (
          <div className="db-body-header sfh-header">
            <p className={`db-body-header-title ${titleStyles}`}>
              {formatAreaName()}
            </p>
            <p className="db-body-header-subtitle">Single Family Homes</p>
          </div>
        ) : (
          <div className="db-body-header">
            <p className={`db-body-header-title ${titleStyles}`}>
              {formatAreaName()}
            </p>
          </div>
        )}

        <div className={`db-indicator-container ${dbIndicatorContainerStyles}`}>
          {sentences.map((sentence, index) => (
            <DBIndicator
              key={sentence.header}
              header={sentence.header}
              logic={sentence.logic}
              statement={sentence.statement}
              benefit={sentence.benefit}
              index={index + 1}
              listgenUserID={listgenUserID}
              mlsAreaID={mlsAreaID}
            />
          ))}
        </div>
        {showBottomLine && (
          <div className={`db-bottom-line ${bottomLineStyles}`}>
            <div className="db-bottom-line-title">TAKE AWAY:</div>{" "}
            <div className="db-bottom-line-text">
              {this.createBottomLine(actualAdvantagesCount, cityOrArea)}{" "}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DBBody;
